import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { userSearchApi, friendApi, conversationApi } from '@formosa/shared/api/im';
import '../../styles/chat.css';

export default function UserSearchPage() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState('');
  const [hits, setHits] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const search = async (e) => {
    e?.preventDefault?.();
    setError('');
    setLoading(true);
    try {
      const data = await userSearchApi.search({ keyword: keyword.trim(), limit: 20 });
      setHits(Array.isArray(data) ? data : data?.data || []);
    } catch (err) {
      setError(err?.message || '搜尋失敗');
      setHits([]);
    } finally {
      setLoading(false);
    }
  };

  const addFriend = async (memberId) => {
    try {
      await friendApi.sendRequest(memberId);
      await search();
    } catch (err) {
      setError(err?.message || '邀請失敗');
    }
  };

  const openChat = async (memberId) => {
    try {
      const conv = await conversationApi.createOrGetDirect(memberId);
      const cid = conv?.conversationId || conv?.id;
      if (cid) navigate(`/chat/${cid}`);
    } catch (err) {
      setError(err?.message || '無法開啟私聊');
    }
  };

  return (
    <div className="chat-social-page">
      <header className="chat-social-page__header">
        <Link to="/chat/contacts" className="chat-link-btn">
          ← 聯絡人
        </Link>
        <h1>搜尋用戶</h1>
      </header>
      <form className="chat-social-page__search" onSubmit={search}>
        <input
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          placeholder="username 或暱稱（至少 2 字）"
          autoComplete="off"
        />
        <button type="submit" disabled={loading}>
          {loading ? '…' : '搜尋'}
        </button>
      </form>
      {error ? <p className="chat-social-page__error">{error}</p> : null}
      <ul className="chat-social-page__list">
        {hits.map((h) => (
          <li key={h.memberId}>
            <div className="chat-social-page__row">
              <span className="chat-social-page__name">{h.displayName || h.username}</span>
              <span className="chat-social-page__meta">
                @{h.username} · {h.friendshipStatus}
                {h.blockedByMe || h.blockedMe ? ' · 已封鎖' : ''}
              </span>
            </div>
            {h.canSendFriendRequest ? (
              <button type="button" className="chat-link-btn" onClick={() => addFriend(h.memberId)}>
                加好友
              </button>
            ) : null}
            {h.canStartConversation ? (
              <button type="button" className="chat-link-btn" onClick={() => openChat(h.memberId)}>
                私聊
              </button>
            ) : null}
            {!h.isSelf ? (
              <Link
                to={`/chat/report?memberId=${encodeURIComponent(h.memberId)}`}
                className="chat-link-btn"
              >
                檢舉
              </Link>
            ) : null}
            {h.incomingRequestStatus === 'PENDING' ? (
              <Link to="/chat/friend-requests" className="chat-link-btn">
                有邀請
              </Link>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
